/*=========================================================================================
  File Name: moduleRegionsState.js
  Description: Regions Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    regions: [],
    regions_detailed: [],
    region_translations: [],
    region_institutions: [],
}
